import React from 'react';
import { BarChart2Icon, PlusIcon } from 'lucide-react';
import { familyMembers } from '../../data/carte';
interface FamilySectionProps {
  selectedId: string;
  onSelect: (id: string) => void;
}
export function FamilySection({
  selectedId,
  onSelect
}: FamilySectionProps) {
  return <section aria-labelledby="family-title" className="mt-8 rounded-3xl bg-slate-50 p-7 sm:p-8" data-id="element-551" data-mp="cypve3mxcwyt">
      <h2 id="family-title" className="text-2xl font-extrabold tracking-tight text-ville-navy" data-id="element-552" data-mp="3bgvetlw6gouj">
        My family
      </h2>

      <ul className="mt-6 grid grid-cols-4 gap-x-4 gap-y-6" data-id="element-553" data-mp="3gewv5z27ya2b">
        {familyMembers.map(member => {
        const active = member.id === selectedId;
        return <li key={member.id} className="text-center" data-id="element-554" data-mp="3lcyf0m7gydeu">
              <div className="inline-block" data-id="element-555" data-mp="3q6b38v88ki72">
                <button type="button" onClick={() => onSelect(member.id)} aria-pressed={active} aria-label={`Show ${member.firstName}’s card`} className="rounded-full transition-transform duration-150 ease-ville hover:-translate-y-0.5 focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-indigo focus-visible:ring-offset-2" data-id="element-556" data-mp="2sq5d40icf839">
                  <img src={member.photo} alt={member.firstName} className={`h-[76px] w-[76px] rounded-full object-cover ring-4 ${active ? 'ring-ville-indigo' : 'ring-white'}`} data-id="element-557" data-mp="1eety6q05vd2o" />
                </button>
              </div>
              <p className="mt-2 text-[15px] font-bold leading-tight text-ville-navy" data-id="element-558" data-mp="14ng44xqzb5gx">{member.firstName}</p>
            </li>;
      })}

        <li data-id="element-559" data-mp="10k1f5hl2berc">
          <button type="button" className="group flex w-full flex-col items-center text-center focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-indigo" data-id="element-560" data-mp="vnkp2huayqbm">
            <span className="grid h-[76px] w-[76px] place-items-center rounded-full bg-white text-slate-400 ring-1 ring-slate-200 transition-colors duration-150 ease-ville group-hover:text-ville-indigo group-hover:ring-ville-indigo" data-id="element-561" data-mp="qqas8h4l3cdr">
              <PlusIcon className="h-7 w-7" aria-hidden="true" data-id="element-562" data-mp="2g2mng7f8qnzs" />
            </span>
            <span className="mt-2 text-[15px] font-bold leading-tight text-ville-indigo" data-id="element-563" data-mp="edyyn6d6xgl6">Add</span>
          </button>
        </li>
      </ul>

      <div className="mt-6 flex items-start gap-3 rounded-2xl bg-ville-indigo-soft px-5 py-4" data-id="element-564" data-mp="j5qo1dkm1g9q">
        <BarChart2Icon className="mt-0.5 h-5 w-5 shrink-0 text-ville-indigo" aria-hidden="true" data-id="element-565" data-mp="4gu8ywk4z2zm" />
        <div className="text-[15px] leading-relaxed text-ville-indigo" data-id="element-566" data-mp="9fxeei413b84">
          <p className="font-semibold" data-id="element-567" data-mp="x4q3bum8git8">Family activities: 3 this week</p>
          <p data-id="element-568" data-mp="x2dqfvvc0yn1">Last use: Emma at the Swimming Pool</p>
        </div>
      </div>
    </section>;
}